import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M5 5.67c0-.406.249-.776.63-.915 7.08-2.594 6.702 3.318 11.677.418.72-.42 1.693.05 1.693.884v7.236a.97.97 0 0 1-.675.93c-7.776 2.403-7.002-4.1-13.325.277V5.67Z" }),
    React.createElement("path", { d: "M5 13h1.5v6.25a.75.75 0 0 1-1.5 0V13Z" })));
export default createSvgIcon(iconPath, "Flag");
//# sourceMappingURL=FlagIcon.js.map